import { useState } from "react";

export const useExportModal = () => {
  const [showExportModal, setShowExportModal] = useState(false);
  const handleOpenExportModal = () => setShowExportModal(true);
  const handleCloseExportModal = () => setShowExportModal(false);

  return { showExportModal, handleOpenExportModal, handleCloseExportModal };
};
